export default __webpack_public_path__ + "static/media/Diamante.7a91dc9e.jpg";